export default {
  en: {
    all: 'All',
    muted: 'Muted',
    group: 'Group',
    direct: 'Direct',
    multi: 'Multi',
  },
};
